module.exports = __webpack_public_path__ + "static/media/module-4000.1694337c.svg";